module.exports = __webpack_public_path__ + "img/AXStv.1ab76665.png";